'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { getValue } from '@/lib/utils'
import Image from 'next/image'
import { useMemo } from 'react'
import { useProductCardContext } from './context/product-card-context'

export const ProductItemImages = () => {
  const { selectedColorVariant, product } = useProductCardContext()

  const images = useMemo(() => {
    return {
      mobile: {
        thumbnail: ImageHelper.getImageUrl(
          getValue(
            selectedColorVariant,
            'variants.0.thumbnail',
            product?.default_thumbnail
          ),
          '355_402'
        ),
        thumbnailHover: ImageHelper.getImageUrl(
          getValue(
            selectedColorVariant,
            'variants.0.thumbnail_hover',
            product?.default_thumbnail_hover
          ),
          '355_402'
        ),
      },
      desktop: {
        thumbnail: ImageHelper.getImageUrl(
          getValue(
            selectedColorVariant,
            'variants.0.thumbnail',
            product?.default_thumbnail
          ),
          '585_663'
        ),
        thumbnailHover: ImageHelper.getImageUrl(
          getValue(
            selectedColorVariant,
            'variants.0.thumbnail_hover',
            product?.default_thumbnail_hover
          ),
          '585_663'
        ),
      },
    }
  }, [
    selectedColorVariant,
    product?.default_thumbnail,
    product?.default_thumbnail_hover,
  ])

  return (
    <div className='group relative block aspect-[4/5] h-full w-full overflow-hidden rounded-lg'>
      <picture>
        <source
          media='(max-width: 768px)'
          srcSet={images.mobile.thumbnail || '/images/logo-mobile.svg'}
        />
        {images.desktop.thumbnail && (
          <Image
            src={images.desktop.thumbnail || '/images/logo-mobile.svg'}
            alt={`${product.title} - ${selectedColorVariant.color}`}
            className='h-full w-full object-cover object-center transition-opacity duration-300 group-hover:opacity-0'
            width={433}
            height={575}
          />
        )}
      </picture>
      <picture>
        <source
          media='(max-width: 768px)'
          srcSet={images.mobile.thumbnailHover}
        />
        {images.desktop.thumbnailHover && (
          <Image
            src={images.desktop.thumbnailHover}
            alt={`${product.title} - ${selectedColorVariant.color}`}
            className='absolute left-0 top-0 h-full w-full object-cover object-top opacity-0 transition-opacity duration-300 group-hover:opacity-100'
            width={433}
            height={575}
            loading='lazy'
          />
        )}
      </picture>
    </div>
  )
}
